import {
    HistoryState,
    NavigationComponentProps,
    Route,
    RouteName,
    RouteParams,
    RouteParamsList,
} from './types'
import {
    freeze,
    go,
    init,
    push,
    replace,
} from './actions'
import router from './router'
import {store} from '../store'

export const navigation = {
    freeze() {
        const {navigation: navigationState} = store.getState()
        store.dispatch(freeze(navigationState))
    },
    hash(event: HashChangeEvent, popstate: HistoryState | null) {
        const [, url] = event.newURL.split('#')

        const route = router.match(url)

        const prev = store.getState().navigation.position
        const next = popstate?.position
        const delta = popstate && prev && next ? next - prev : null

        if (delta) {
            store.dispatch(go(delta))
        } else if (route) {
            store.dispatch(push(route))
        }
    },
    init(route?: Route) {
        store.dispatch(init(route))
    },
    params<K extends keyof RouteParamsList>(props: NavigationComponentProps<K>) {
        return props.params
    },
    push(name: RouteName, params?: RouteParams) {
        store.dispatch(push({
            name,
            params,
        }))
    },
    replace(name: RouteName, params?: RouteParams) {
        store.dispatch(replace({
            name,
            params,
        }))
    },
    route: {
        params<K extends keyof RouteParamsList>(route: Route | null): RouteParamsList[K] {
            if (!route) {
                return undefined as never
            }

            return route.params as RouteParamsList[K]
        },
    },
}
